import { TextButton as Button } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

interface PaymentsWrapperProps {
  isCpoOffer: boolean;
  isFeatured?: boolean;
}

export const TileWrapper = styled.div<{ isCpoOffer: boolean }>`
  width: 339px;
  background-color: ${COLORS.white};
  padding: 24px 24px 12px 24px;
  min-height: ${({ isCpoOffer }) => (isCpoOffer ? '733px' : '855px')};
  /* min-height: 255px; */
  display: flex;
  flex-direction: column;
  /* align-items: center; */
`;

export const TagAndDagWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`;

export const DagLabel = styled.p``;

export const NameAndTrimWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  min-height: 64px;
`;

export const ImageWrapper = styled.div<{ isCpoOffer: boolean }>`
  margin: ${({ isCpoOffer }) => (isCpoOffer ? '16px 0 8px 0' : '16px 0')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const VehicleImage = styled.img`
  width: 260px;
  height: 154px;
  object-fit: cover;
  scale: 1.1;
  @media ${device.mobileL} {
    width: 296px;
  }
`;

export const ImageDiscalimer = styled.p`
  font-size: 10px;
`;

export const VehicleInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CpoOffersWrapper = styled.div<{ isModal?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${({ isModal }) => (isModal ? '24px' : '12px')};
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
`;

export const Price = styled.div`
  position: relative;
`;

export const CpoLabelWrapper = styled.div`
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const OfferInfo = styled.div<{ isCpoOffer: boolean }>`
  padding: 16px 0;
  width: 100%;
  min-height: ${({ isCpoOffer }) => (isCpoOffer ? '164px' : '297px')};
`;

export const PriceCopy = styled.h4<{ isBold?: boolean; smallFont?: boolean; color?: string }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: ${(props) => (props.smallFont ? '16px' : '18px')};
  line-height: 24px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${({ color }) => color || COLORS.grey80};
`;

export const PaymentsWrapper = styled.div<PaymentsWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ isCpoOffer, isFeatured }) => {
    if (isFeatured) return '8px';
    if (isCpoOffer) return '12px';
    return '16px';
  }};
`;

export const PaymentsItem = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  display: flex;
  flex-direction: column;
`;

export const PricingOptionsWrapper = styled.div`
  flex: 1;
`;

export const ExpiryDetails = styled.div<{ marginTop?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  /* margin-top: 12px; */
`;

export const Divider = styled.div`
  width: 1px;
  background-color: ${COLORS.grey15};
`;

export const PaymentsTileContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const OfferDescriptions = styled.div`
  max-height: 164px;
  overflow-y: auto;
`;

export const MainOffer = styled.div<{ isModal?: boolean }>`
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: row;
  gap: ${({ isModal }) => (isModal ? '24px' : '16px')};
`;
export const PercentData = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: ${({ isFeatured }) => (isFeatured ? '135px' : '125px')};
`;
export const PaymentData = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: ${({ isFeatured }) => (isFeatured ? '135px' : '125px')};
`;

export const CreditBonus = styled.div<{ isFeatured?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: ${({ isFeatured }) => isFeatured && '8px'};
`;
export const Extra = styled.div`
  /* padding: 16px 0; */
  p {
    color: ${COLORS.grey60};
  }
`;

export const ExpiryTextWrapper = styled.div``;

export const OfferModalCta = styled.div`
  a {
    padding: 0;
    min-height: 0;
    font-weight: 700;
    color: ${COLORS.grey60};
    border-bottom: 1px solid ${COLORS.grey60};
    line-height: 20px;
    padding-bottom: 2px;
  }
`;

export const PriceDisclaimer = styled.p`
  padding-top: 8px;
  font-size: 12px;
  text-align: center;
`;

export const WhyBuy = styled.div<{ disabledCta?: boolean }>`
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  a {
    pointer-events: ${({ disabledCta }) => (disabledCta ? 'none' : 'auto')};
    cursor: ${({ disabledCta }) => (disabledCta ? 'not-allowed' : 'pointer')};
    color: ${({ disabledCta }) => (disabledCta ? COLORS.grey30 : COLORS.black)};
    :hover {
      ${({ disabledCta }) => (disabledCta ? COLORS.grey30 : COLORS.black)};
    }
  }
`;

export const CpoOffer = styled.div`
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
export const Apr = styled.div`
  font-size: 12px;
  line-height: 20px;
`;
export const Percent = styled.div`
  /* font-weight: 700; */
  position: relative;
`;

export const Term = styled.div`
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
`;

export const SuperScript = styled.div`
  position: absolute;
  /* width: 24px;
  height: 24px; */
  top: -12px;
  right: -24px;
  .link {
    padding: 12px;
  }
`;
